var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "collection-shop-the-look-tile zoom-transition",
      on: { click: _vm.openShopTheLook }
    },
    [
      _c("img", {
        staticClass: "collection-shop-the-look-tile__image",
        attrs: {
          src: _vm.shopTheLookTile.imageUrl,
          alt: _vm.shopTheLookTile.imageAlt
        }
      }),
      _c("div", { staticClass: "collection-shop-the-look-tile__text" }, [
        _c("h3", [_vm._v(_vm._s(_vm.shopTheLookTile.title))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }